/**
 * 백엔드 REST 베이스 URL (`…/api/v1` 까지, 끝 슬래시 없음).
 * 동일 출처 리버스 프록시(통합 Docker 등)에서는 `/api/v1` 처럼 상대 경로를 쓸 수 있습니다.
 * REACT_APP_API_BASE_URL 미설정 시 로컬 톰캣 기본값.
 */
const DEFAULT_API_BASE_URL = 'http://localhost:8080/investment-diary-api/api/v1';

function normalizeApiBaseUrl(raw: string | undefined): string {
  const trimmed = raw?.trim();
  if (!trimmed) {
    return DEFAULT_API_BASE_URL;
  }
  return trimmed.replace(/\/+$/, '');
}

export const API_BASE_URL = normalizeApiBaseUrl(process.env.REACT_APP_API_BASE_URL);
